import React from 'react';
import CrudPage from '../../../components/CrudPage';
import useLookups from '../../../hooks/useLookups';
import { Button, Badge } from '../../../components/common';
import { AUDIT_COLUMNS } from '../../../config/columns';
import { apiError } from '../../../services/api';
import { beneficiaryService, nationalityService } from '../../../services/resources';

export default function BeneficiaryPage({ onToast }) {
  const lookups = useLookups({
    nationalities: { service: nationalityService, labelKey: (r) => r.nationality_name },
  });
  const labelFor = (name, id) => lookups[name]?.find((o) => o.value === id)?.label ?? id;

  const toggleBlock = async (row, reload) => {
    try {
      if (row.is_blocked) {
        await beneficiaryService.unblock(row.id);
        onToast?.('Beneficiary unblocked');
      } else {
        await beneficiaryService.block(row.id);
        onToast?.('Beneficiary blocked');
      }
      reload();
    } catch (err) {
      onToast?.(apiError(err).message, 'error');
    }
  };

  return (
    <CrudPage
      title="Beneficiary"
      formCode="BENEFICIARY"
      service={beneficiaryService}
      onToast={onToast}
      lookups={lookups}
      formColumns={2}
      searchKeys={['beneficiary_name', 'account_no', 'bank_name']}
      columns={[
        { key: 'beneficiary_name', label: 'Name' },
        { key: 'nationality_id', label: 'Country', render: (r) => labelFor('nationalities', r.nationality_id) },
        { key: 'bank_name', label: 'Bank' },
        { key: 'swift_code', label: 'Swift Code' },
        { key: 'account_no', label: 'Account No' },
        {
          key: 'is_blocked',
          label: 'Status',
          render: (r) => (r.is_blocked ? <Badge tone="red">Blocked</Badge> : <Badge tone="green">Active</Badge>),
        },
        ...AUDIT_COLUMNS,
      ]}
      fields={[
        { key: 'beneficiary_name', label: 'Beneficiary Name', type: 'text', required: true, uppercase: true },
        { key: 'nationality_id', label: 'Country', type: 'select', required: true, lookup: 'nationalities' },
        { key: 'bank_name', label: 'Bank Name', type: 'text' },
        { key: 'swift_code', label: 'Swift Code / BIC', type: 'text' },
        { key: 'account_no', label: 'Account No / IBAN', type: 'text' },
        { key: 'id_number', label: 'ID / Passport No', type: 'text' },
        { key: 'phone', label: 'Phone', type: 'text' },
        { key: 'address', label: 'Address', type: 'textarea' },
      ]}
      rowActions={(row, { reload }) => (
        <Button
          size="sm"
          variant={row.is_blocked ? 'secondary' : 'ghost'}
          onClick={() => toggleBlock(row, reload)}
        >
          {row.is_blocked ? 'Unblock' : 'Block'}
        </Button>
      )}
    />
  );
}
